import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-applicant-funnel-message-dialog',
    templateUrl: './applicant-funnel-message-dialog.html',
})
export class ApplicantFunnelMessageDialogComponent {
    @Input() subject: string;
    @Input() openDialog = false;

    @Output() confirmChangeFunnelStage = new EventEmitter();
    @Output() closeChangeFunnelStage = new EventEmitter();

    onClose(): void {
        this.closeChangeFunnelStage.emit();
    }

    onConfirm(): void {
        this.confirmChangeFunnelStage.emit();
    }
}
